import { render, staticRenderFns } from "./LayoutColumnHeaderBranded.vue?vue&type=template&id=263845c0&"
import script from "./LayoutColumnHeaderBranded.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnHeaderBranded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports